import { Input } from '@frontend/components/form'
import { Button } from '@nextui-org/react'
import { useCallback } from 'react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'

import type { ForgetPasswordState } from './lib/type'

import { useLostPassword } from './lib/hook'

export function ForgetPasswordForm() {
  const navigate = useNavigate()
  const { control, handleSubmit, reset } = useForm<ForgetPasswordState>({
    defaultValues: {
      username: '',
    },
    mode: 'onTouched',
  })

  const { isLoading, mutate } = useLostPassword()

  const onSubmit = useCallback(
    async (data: ForgetPasswordState) => {
      await toast.promise(mutate(data), {
        error: (error) => error?.message || 'Failed to forget password',
        loading: 'Forgetting password...',
        success: (response) => {
          reset()
          navigate('/my-account')
          return response?.message || 'Forgot password successfully'
        },
      })
    },
    [mutate, navigate, reset],
  )

  return (
    <>
      <h2 className="mb-2 font-medium uppercase">Lost your password?</h2>
      <small>
        Please enter your username or email address. You will receive a link to
        create a new password via email.
      </small>
      <form
        className="relative mt-6 space-y-6"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Input
          control={control}
          fieldProps={{
            autoComplete: 'username',
            label: 'Username or Email Address',
            variant: 'bordered',
          }}
          name="username"
          rules={{
            required: 'Please enter your username or email address',
          }}
        />

        <Button
          className="font-medium"
          color="primary"
          fullWidth
          isLoading={isLoading}
          size="lg"
          type="submit"
        >
          Reset Password
        </Button>
      </form>
    </>
  )
}

export default ForgetPasswordForm
